"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyMask = applyMask;
exports.createMask = createMask;
exports.createSensitiveDetailMask = createSensitiveDetailMask;
exports.emailMask = emailMask;
function emailMask(email) {
  return '********@' + email.split('@')[1];
}
function createMask(field, mask) {
  let replace;
  if (typeof mask === 'function') {
    replace = mask;
    mask = true;
  }
  return {
    re: typeof field === 'string' ? new RegExp(`"${field}":\\s*"([^"]+)"`, 'i') : field,
    mask: !!mask,
    replace
  };
}
function createSensitiveDetailMask(masks) {
  const sensitiveDetailMask = data => {
    let match;
    let result = data;
    for (const {
      re,
      mask,
      replace
    } of masks) {
      let count = 0;
      let startAt = 0;
      while (match = re.exec(result.substring(startAt))) {
        const matchIndex = match.index + startAt;
        const matchText = match[0];
        const findText = match[1];
        const replaceText = replace ? replace(findText) : mask === true ? applyMask(findText) : '********';
        const newText = matchText.replace(findText, replaceText);
        result = result.substring(0, matchIndex) + newText + result.substring(matchIndex + matchText.length);
        startAt = matchIndex + newText.length;
        count++;
        if (count > 1000) {
          throw new Error('There is something wrong in the maskSensitiveDetail function.');
        }
      }
    }
    return result;
  };
  return sensitiveDetailMask;
}
function applyMask(text) {
  if (!text) {
    return text;
  }
  text = '' + text;
  const len = text.length;
  let start;
  if (len >= 7) {
    start = text.length - 4;
  } else if (len >= 5) {
    start = 3;
  } else if (len >= 3) {
    start = 2;
  } else {
    start = 1;
  }
  return '*'.repeat(start) + text.substring(start);
}